import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { environment } from '../../../environments/environment';
import { TCCPHttpService } from '../../shared/services/tccp-http.service';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPLoggerService } from '../../shared/services/tccp-logger.service';
import { capability } from '../../shared/models/Capability';

@Injectable({
  providedIn: 'root'
})
export class ManageCvsMappingService {
  public appBase = TCCPConstantValues[environment.applicationName];
  public baseURL = this.appBase.Urls;
  public pageMode: string = null;
  public selectedCapability: string = null;
  constructor(
    private httpService: TCCPHttpService, private logger: TCCPLoggerService) { }

  getCapabilityList(division: string, capability?: string, ): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.getCapabilityList,
      'Started getting capability list', '');
    let url = '';
    if (capability === undefined) {
      url = this.baseURL['CAPABILITY_CONTEXT'] + division;
    } else {
      url = this.baseURL['CAPABILITY_CONTEXT'] + division + '/' + capability;
    }
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.getCapabilityList,
            'Getting Capability successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.getCapabilityList,
            'Getting capability failed', '', error);
          return error;
        })
    );
  }

  /** For service call to update CVS Capability
  * @class ManageCvsMappingService
  * @method updateCVSCapability
  * @param capability
  * @returns Observable
  */
  updateCVSCapability(capability: capability, capabilityName: string, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
      'Started getting flow', '');
    const url = this.baseURL['CAPABILITY_CONTEXT'] + division + '/' + capabilityName;
    return this.httpService.put(url, capability).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to insert CVS Capability
  * @class ManageCvsMappingService
  * @method insertCVSCapability
  * @param capability 
  * @returns Observable
  */
  insertCVSCapability(capability: capability): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
      'Started getting flow', '');
    const url = this.baseURL['CAPABILITY_CONTEXT'];
    return this.httpService.post(url, capability).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to insert CVS Capability
 * @class ManageCvsMappingService
 * @method deleteCVSCapability 
 * @returns Observable
 */
  deleteCVSCapability(capability: string, division: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
      'Started getting flow', '');
    const url = this.baseURL['CAPABILITY_CONTEXT'] + division + '/' + capability;
    return this.httpService.delete(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.CAPABILITY_MODULE, this.appBase.methods.saveCapabilityList,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }
}
